import { render, staticRenderFns } from "./HeaderMenuSignin.vue?vue&type=template&id=316f1170"
import script from "./HeaderMenuSignin.vue?vue&type=script&lang=js"
export * from "./HeaderMenuSignin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports